import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
    selector: "app-grid-page-selector",
    templateUrl: "./grid-page-selector.component.html",
    styleUrls: ["./grid-page-selector.component.scss"],
    standalone: false
})
export class GridPageSelectorComponent implements AfterViewInit, OnDestroy {
  private readonly ngUnsubscribe = new Subject<boolean>();
  changePageSubject = new Subject<string>();
  @Input() grid: DxDataGridComponent;
  @ViewChild("pageSelectorInput") pageSelectorInput: ElementRef;
  isVisible = false;

  ngAfterViewInit() {
    this.changePageSubject
      .pipe(
        takeUntil(this.ngUnsubscribe),
        distinctUntilChanged(),
        debounceTime(500)
      )
      .subscribe((page) => {
        this.changePage(page);
      });

    this.grid.instance.on("contentReady", (e) => {
      this.isVisible = this.grid.instance.pageCount() > 1;
      if (
        this.pageSelectorInput &&
        this.grid.instance.pageIndex() + 1 !==
          +this.pageSelectorInput.nativeElement.value
      ) {
        this.pageSelectorInput.nativeElement.value = "";
      }
    });
  }

  changePage(page) {
    if (+page === 0) {
      this.pageSelectorInput.nativeElement.value = 1;
      page = "1";
    }
    if (this.grid.instance.pageCount() < +page) {
      this.pageSelectorInput.nativeElement.value =
        this.grid.instance.pageCount();
    }
    if (page !== "") {
      this.grid.instance.pageIndex(+page - 1);
    }
  }

  onPageChange(page: string): void {
    this.changePageSubject.next(page);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
